<template>
  <v-container>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <h1>Distractions and Types</h1>
    <h2>Distraction Types</h2>
    <v-btn to="/admin/distractions/types/new">Add</v-btn>
    <v-data-table
      :headers="typeHeaders"
      :items="types"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.index }}</td>
        <td>{{ props.item.title }}</td>
        <td>
          <v-icon
            small
            @click="editItem(props.item, 'type')"
          >edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item, 'type')"
          >delete_forever
          </v-icon>
        </td>
      </template>
    </v-data-table>
    <h2>Distractions</h2>
    <v-btn to="/admin/distractions/new">Add</v-btn>
    <v-data-table
      :headers="distractionHeaders"
      :items="distractions"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.typeTitle }}</td>
        <td>{{ props.item.body }}</td>
        <td>
          <v-icon
            small
            @click="editItem(props.item, 'distraction')"
          >edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item, 'distraction')"
          >delete_forever
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isError: false,
    errMessage: null,
    types: [],
    typeHeaders: [
      { text: '#', value: 'index' },
      { text: 'Title', value: 'title' },
      { text: 'Actions', value: 'index' } // no actual value
    ],
    distractions: [],
    distractionHeaders: [
      { text: 'Type', value: 'typeTitle' },
      { text: 'Body', value: 'body' },
      { text: 'Actions', value: 'setTitle' } // no actual value
    ]
  }),
  mounted: function () {
    var _this = this
    this.axios.get('/distractions/types')
      // Get type information
      .then(function (res) {
        _this.types = res.data

        // Now get distraction information
        _this.axios.get('/distractions')
          .then(function (res) {
            // Get a mapping of type IDs to type titles
            let map = {}
            for (let i in _this.types) {
              let type = _this.types[i]
              map[type.id] = type.title
            }

            // Add the typeTitle attribute to each of our returned distractions
            for (let i in res.data) {
              res.data[i].typeTitle = map[res.data[i].typeID]
            }

            // Now store our updated data as our devotionals
            _this.distractions = res.data
          })
          .catch(_this.$root.apiErrorHandler())
      })
      .catch(this.$root.apiErrorHandler())
  },
  methods: {
    editItem: function (item, type) {
      let url = '/admin/distractions/' + item.id
      if (type === 'type') {
        url = '/admin/distractions/types/' + item.id
      }

      this.$router.push(url)
    },
    deleteItem: function (item, type) {
      // Determine our request details based on arguments
      let url = '/distractions'
      if (type === 'type') {
        url += '/types'
      }
      url += '/' + item.id

      // Confirm with the user that they want to perform the requested action
      // before actually making the request
      var _this = this
      confirm('Do you want to remove this item?') &&
      this.axios.delete(url)
        .then(function (res) {
          let list = _this.distractions
          if (type === 'type') {
            list = _this.types
          }

          // Find the index of our item in its list
          var index = null
          for (var i in list) {
            if (list[i].id === item.id) {
              index = i
              break
            }
          }
          if (index !== null) {
            // Remove the proper row from the list
            list.splice(index, 1)
          } else {
            _this.errMessage = 'An error occurred. Please try again.'
            _this.isError = true
          }
        })
        .catch(this.$root.apiErrorHandler(function (msg) {
          _this.errMessage = msg
          _this.isError = true
        }))
    }
  }
}
</script>
